import { render, staticRenderFns } from "./ServerModal.vue?vue&type=template&id=38af5b72&"
import script from "./ServerModal.vue?vue&type=script&lang=ts&"
export * from "./ServerModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports